import { connect } from 'react-redux';
import * as RX from 'reactxp';
import { Window } from '../../reducers/window';
import { mapStateToProps } from '../../utils/mapper';
import { colors } from '../../utils/styles';

interface SpinnerProps {
  dispatch: ({ type }: { type: string, [key: string]: any}) => void;
  window: Window;
  submitting: { submitting?: boolean };
} ;

const styles = (multiplier) => ({
  button: RX.Styles.createButtonStyle({
    padding: 0,
    position: 'absolute',
    right: 16 * multiplier,
    top: 16 * multiplier,
  }),
  close: RX.Styles.createTextStyle({
    fontSize: 20 * multiplier,
    fontWeight: 'bold',
  }),
  spinner: RX.Styles.createViewStyle({
    alignItems: 'center',
    backgroundColor: colors.white,
    height: 300 * multiplier,
    justifyContent: 'center',
    minWidth: 300 * multiplier,
    padding: 16 * multiplier,
  }),
  wrapper: RX.Styles.createViewStyle({
    alignItems: 'center',
    backgroundColor: 'rgba(204, 204, 204, .6)',
    justifyContent: 'center',
    left: 0,
    position: 'absolute',
  }),
});

export class Spinner extends RX.Component<SpinnerProps, RX.CommonProps & SpinnerProps> {
  constructor(props: SpinnerProps) {
    super(props);
  }

  public render() {
    const { window: { height, width, multiplier }, submitting: { submitting } } = this.props;
    return (
      submitting ? <RX.View
      style={[styles(multiplier).wrapper, { top: window ? window.pageYOffset : 0, width, height }]}>
        <RX.View style={styles(multiplier).spinner}>
          <RX.ActivityIndicator color={colors.primary} size='large' />
        </RX.View>
      </RX.View> : null
    );
  }
}

export default connect(mapStateToProps)(Spinner);



// WEBPACK FOOTER //
// ./src/components/spinner/index.tsx